import {CommentsPeek} from "#/src/pages/(profile)/CommentsPeek";
import {ShoutboxPeek} from "#/src/pages/(profile)/ShoutboxPeek";
import {SidebarSocials} from "#/src/pages/(profile)/profile/@id/SidebarSocials";
import {VideosPeek} from "#/src/pages/(profile)/VideosPeek";

export function Content() {
  return <main>
    <section className="profil">
      <div className="container-xxl">
        <div className="row">
          <SidebarSocials/>
          <div className="col-xl-9">
            <VideosPeek/>
            <CommentsPeek/>
            <ShoutboxPeek/>
          </div>
        </div>
      </div>
    </section>
  </main>
}